var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlotCardIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7794 7.5C28.7794 8.52125 28.342 9.44034 27.6443 10.0802L49.7976 11.8424C50.894 11.9296 51.7142 12.8858 51.6336 13.9827L49.3987 44.3766C49.3292 45.3221 48.6055 46.0889 47.6656 46.2128L33.7504 48.0478C33.7695 48.1958 33.7794 48.3468 33.7794 48.5C33.7794 50.433 32.2124 52 30.2794 52C28.5033 52 27.0363 50.6772 26.8097 48.963L6.2617 51.6727C4.98982 51.8404 3.89116 50.7842 4.00863 49.5067L7.59847 10.4672C7.69873 9.37685 8.65714 8.56982 9.74866 8.65665L22.5361 9.67383C22.0623 9.07675 21.7794 8.32142 21.7794 7.5C21.7794 5.567 23.3464 4 25.2794 4C27.2124 4 28.7794 5.567 28.7794 7.5Z",
    fill: "#DFE2E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0182 15.8424L13.9693 12.6566C12.8778 12.5698 11.9194 13.3769 11.8191 14.4672L8.22927 53.5067C8.1118 54.7842 9.21046 55.8404 10.4823 55.6727L51.8862 50.2128C52.8261 50.0889 53.5498 49.3221 53.6194 48.3766L55.8542 17.9827C55.9349 16.8858 55.1146 15.9296 54.0182 15.8424Z",
    fill: "#DFFBE8",
    stroke: "#00004B",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 11.5L34.5 52.5",
    stroke: "#00004B",
    strokeLinecap: "square",
    strokeDasharray: "1 2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 11.5,
    r: 3,
    fill: "white",
    stroke: "#00004B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 52.5,
    r: 3,
    fill: "white",
    stroke: "#00004B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotCardIcon1);
export default __webpack_public_path__ + "static/media/PlotCardIcon1.bf0dd305ee6cb4be890c7164d7f536bf.svg";
export { ForwardRef as ReactComponent };